import { PurchaseOrderTransition } from '@synergy/models';

export const changePurchaseOrderToCredit = (transitionObject: PurchaseOrderTransition) => {
    transitionObject.surcharge = Math.abs(transitionObject.surcharge) * -1;
    transitionObject.deliveryPrice = Math.abs(transitionObject.deliveryPrice) * -1;

    transitionObject.purchaseOrderItems = transitionObject.purchaseOrderItems.map(purchaseOrderItem => {
        return { ...purchaseOrderItem, price: Math.abs(purchaseOrderItem.price) * -1 };
    });

    return transitionObject;
};
